import Vue from 'vue';
import Vuex from 'vuex';
import Cookies from 'js-cookie';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    apiKey: Cookies.get('token') ? Cookies.get('token') : '',
    apiGatewaysKey: Cookies.get('token2') ? Cookies.get('token2') : ''
  },
  getters: {
    auth: state => state.apiKey,
    authGateways: state => state.apiGatewaysKey
  },
  mutations: {
    setToken(state, token) {
      state.apiKey = token;
      Cookies.set('token', token, { expires: 1 })
    },
    setGatewaysToken(state, token) {
      state.apiGatewaysKey = token;
      Cookies.set('token2', token, { expires: 1 })
    }
  }
});
